module.exports = __webpack_public_path__ + "img/VU.40824f44.png";